import { createFrontendPlugin, PageBlueprint } from '@backstage/frontend-plugin-api';
import HomeIcon from '@material-ui/icons/Home';

export const portalPlugin = createFrontendPlugin({
  pluginId: 'snap',
  extensions: [
    PageBlueprint.make({ name: 'source-docs', params: { path: '/source-docs', title: 'Source documentation', loader: () => import('./SourceDocs').then(m => <m.SourceDocs />) } }),
    PageBlueprint.make({ name: 'overview', params: { path: '/', title: 'Engineering', icon: <HomeIcon />, loader: () => import('./Overview').then(m => <m.Overview />) } }),
  ],
});
